export enum TtsPlayerMode {
  IFRAME = 'iframe',
  EMBED = 'embed'
}

import type { Ref } from 'vue'

export interface TtsStateInterface {
  initialized: boolean
  mounted: boolean
  open: boolean
}

export interface TtsOptionsInterface {
  automount: boolean
  autoopen: boolean
  autoplay: boolean
  targetId: string
  container: HTMLElement | null,
  baseUrl: string | null
}

export interface TtsPropertiesInterface {
  id?: string
  source?: string
  site?: string
  voice?: string
  player: string
  startTime?: number
}

export interface TtsCommandInterface {
  command: string | null
  data: any | null
}

export interface EmbedAppPropsInterface {
  state: Ref<TtsStateInterface>
  options: Ref<TtsOptionsInterface>
  properties: Ref<TtsPropertiesInterface>
  command: Ref<TtsCommandInterface>
}

export interface TtsObject {
  state: Ref<TtsStateInterface>
  properties: Ref<TtsPropertiesInterface>
  options: Ref<TtsOptionsInterface>

  dispatch (type:string, data?:any): void
  mount(): void
  open (id?: string): void
  close(): void
  stop(): void
  play(id?: string): void
  pause(): void
  destroy(): void

  initialize(): void

  setProperty(name: string, value: any): void
  getProperty(name: string): any

  setOption(name: string, value: any): void
  getOption(name: string): any
}

export interface TtsEvent {
  detail: {
    instance: TtsObject,
    data?: any
  }
}
